import React from 'react';
import { useRoom } from '../context/RoomContext';
import './WaitingRoomPanel.css';

const WaitingRoomPanel = ({ isOpen, onClose }) => {
  const { waitingRoomUsers, approveFromWaitingRoom, denyFromWaitingRoom, room, socketId } = useRoom();

  if (!isOpen) return null;

  // Check if current user is the host
  const isHost = room?.hostId === socketId;

  if (!isHost) return null;

  const handleApprove = (participantId) => {
    approveFromWaitingRoom(participantId);
  };

  const handleDeny = (participantId) => {
    denyFromWaitingRoom(participantId);
  };

  return (
    <div className="waiting-room-panel">
      <div className="waiting-room-panel-header">
        <h3>Salle d'attente</h3>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
      
      <div className="waiting-room-panel-content">
        {waitingRoomUsers.length === 0 ? (
          <div className="empty-waiting-room">
            <p>Aucun utilisateur en attente</p>
          </div>
        ) : (
          <ul className="waiting-room-list">
            {waitingRoomUsers.map((user) => (
              <li key={user.id} className="waiting-room-item">
                <div className="user-info">
                  <span className="user-name">{user.name}</span>
                  <span className="waiting-time">
                    En attente depuis {formatWaitingTime(user.requestedAt)}
                  </span>
                </div>
                <div className="waiting-room-actions">
                  <button
                    className="approve-btn"
                    onClick={() => handleApprove(user.id)}
                    title="Approuver"
                  >
                    ✓
                  </button>
                  <button
                    className="deny-btn"
                    onClick={() => handleDeny(user.id)}
                    title="Refuser"
                  >
                    ✗
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

// Helper function to format waiting time
const formatWaitingTime = (requestedAt) => {
  const now = new Date();
  const requested = new Date(requestedAt);
  const diffMs = now - requested;
  const diffMins = Math.floor(diffMs / 60000);
  const diffSecs = Math.floor((diffMs % 60000) / 1000);
  
  if (diffMins > 0) {
    return `${diffMins}m ${diffSecs}s`;
  }
  return `${diffSecs}s`;
};

export default WaitingRoomPanel;
